import { render, staticRenderFns } from "./getfree.vue?vue&type=template&id=5bd33478&scoped=true"
import script from "./getfree.vue?vue&type=script&lang=js"
export * from "./getfree.vue?vue&type=script&lang=js"
import style0 from "./getfree.vue?vue&type=style&index=0&id=5bd33478&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd33478",
  null
  
)

export default component.exports